// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__16nR9","left":"InfoRow_left__1E0Zf"};